import "./Sustainability.css";

const Sustainability = () => {
  return (
    <div>
      <div className="hero_img sus_img">
        <img src="/assets/Sustainability/sustain.jpg" alt="" />
      <div className="hero_title ">Our Sustainability Initiatives</div>

      </div>
      <div className="container2">
        <div className=" portp_div2 container ">
          <div className="portp_div21  ">
            <h2>
              Towards a Sustainable Digital <br /> Infrastructure Solution
            </h2>
            <p>
              We strive to operate in an inclusive environment where we can
              support the communities we serve, the environment in which we have
              an impact, and our employees’ overall well-being.
            </p>
            <p>
              Given the energy-intensive nature of the telecom sector, we have
              consistently strived to remain at the forefront of developing a
              Sustainable Digital Infrastructure through our comprehensive
              offerings, operational expertise, and top-notch human capital.
            </p>
            <p>
              Environment, Social, and Governance (ESG) is not merely a checkbox
              for us; instead, we intend to develop a roadmap that is equitable,
              resilient, and sustainable and that can help India’s Digital
              Transformation move in the right direction.
            </p>
          </div>
          <div className="portp_div31">
            <img src="/assets/Sustainability/sustainimg1.jpg" alt="" />
          </div>
        </div>

        <div className="portp_div2 policies_flex container ">
          <div className="portp_div31">
            <img src="/assets/Sustainability/sustainimg2.jpg" alt="" />
          </div>
          <div className="portp_div21  ">
            <h2>Environment</h2>
            <p>
              Crest Digitel recognizes its responsibility to protect the
              environment and is committed to regulating all its activities to
              follow the best practices for minimizing adverse environmental
              impact arising from its operations. All of Crest’s sites are
              diesel generator free, which is a benchmark in the industry. We
              also make sure that electronic waste is given to
              government-certified organizations in accordance with e-waste
              disposal rules and that batteries are handed over to
              government-certified organizations for disposal in accordance with
              hazardous waste management rules. We also optimize the usage of
              CNG vehicles as part of our green initiative to reduce carbon
              footprint in logistics and transportation. Our objective is to
              continue to be an environmentally responsible organization making
              continuous improvements in the management of the environmental
              impact of our operations.
            </p>
          </div>
        </div>

        <div className="portp_div2  container ">
          <div className="portp_div21  ">
            <h2>Social</h2>
            <p>
              Through a variety of programs, we intend to address and enhance
              the health, confidence, and holistic well-being of our employees
              in all 22 telecom circles where we operate. Crest firmly believes
              that occupational Health, Safety, Security of its employees and
              associates, and the protection of the Environment override all
              other business targets. To accomplish our target of ZERO serious/
              high risk/ adverse safety incidents we provide regular training to
              our colleagues and follow the 7 safety rules.
            </p>
            <p>
              RRR (Rejuvenate Refresh Recharge) and #CrestFit are our flagships
              a program that aims to empower employees to develop and sustain
              healthy lifestyle choices. We guide employees in identifying their
              well-being quotient and provide expert-led assistance, customized
              sessions, and counseling support, among other initiatives.
            </p>
          </div>
          <div className="portp_div31">
            <img src="/assets/Sustainability/sustainimg3.jpg" alt="" />
          </div>
        </div>

        <div className="portp_div2 policies_flex container ">
          <div className="portp_div31">
            <img src="/assets/Sustainability/sustainimg4.jpg" alt="" />
          </div>
          <div className="portp_div21  ">
            <h2>Governance</h2>
            <p>
              Guided by values and principles, our Corporate Governance has
              remained our beacon of light and has always helped to move in the
              right direction. With a strong governance structure and an
              ambitious sustainability agenda to address the issues that are
              close to our hearts, we are making progress toward our ESG
              commitments to drive change and contribute to the widespread
              adoption of sustainable living.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sustainability;
